import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_Textletter_Interface, Textletter_Interface } from 'src/app/Interface/Textletter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TextletterService } from 'src/app/Service/Textletter/Textletter.service';

@Component({
  selector: 'app-TextletterEdit',
  templateUrl: './TextletterEdit.component.html',
  styleUrls: ['./TextletterEdit.component.scss']
})
export class TextletterEditComponent implements OnInit {


  Token:String=""
  EditRecord:Number

  constructor(
    private Textletter_Service:TextletterService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditTextletter=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
      Semat:new FormControl(null,Validators.required),
      Name:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token,-1).subscribe(
      data=>{
        this.Textletter_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Dsc().setValue(data.dsc)
            this.get_Form_Semat().setValue(data.semat)
            this.get_Form_Name().setValue(data.name)

          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    EditTextletter:FormGroup;

    get_Form_Id(){
      return this.EditTextletter.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditTextletter.get('Title') as FormControl;
    }

    get_Form_Dsc(){
      return this.EditTextletter.get('Dsc') as FormControl;
    }

    get_Form_Semat(){
      return this.EditTextletter.get('Semat') as FormControl;
    }

    get_Form_Name(){
      return this.EditTextletter.get('Name') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditTextletter(){
      var Record:Textletter_Interface =Empty_Textletter_Interface()
      Record.id=this.get_Form_Id().value
      Record.semat=this.get_Form_Semat().value
      Record.dsc=this.get_Form_Dsc().value
      Record.name=this.get_Form_Name().value
      this.InProccessing=true
      this.Textletter_Service.EditText_letter(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else{

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }



}
